import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { STEPS_HISTORY_PENSION } from "./steps.const";
import { EDAD_MINIMA_PREGUNTAS_PGU, STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY } from "@constants/tramite-pension-constant";
import { StorageService } from "@services/storage/storage.service";
import { BASIC_CLIENT_INFO } from "@constants/data-service.constant";
import { Util } from '../../../../shared/common/utils/util';

@Component({
    selector: "app-modal-pension-history",
    templateUrl: "./modal-pension-history.component.html",
    styleUrls: ["./modal-pension-history.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalPensionHistoryComponent implements OnInit {
  public data: any;
  radioCurrentValue: boolean;
  form: FormGroup;
  activeBtn: boolean = true;
  currentStepIndex = 0;
  steps = STEPS_HISTORY_PENSION;

  constructor(
    private readonly formBuilder: FormBuilder,
    public modal: ModalController,
    private readonly storageService: StorageService,
    private readonly util: Util){
    this.createForm();
  }

  async ngOnInit(): Promise<void> {
    await this.filtrarPreguntas();
    await this.loadFormData();
  }

 async filtrarPreguntas() {
    const client = await this.storageService.get(BASIC_CLIENT_INFO);
    const edad = this.util.calcularEdad(client.birthDate);
    if (edad < EDAD_MINIMA_PREGUNTAS_PGU) {
      this.steps = this.steps.filter(step => step.controlName !== 'pgu');
      this.form.removeControl('pgu');
    }
  }

  get tituloPasos() {
    return `Pregunta ${this.currentStepIndex + 1} de ${this.steps.length}`;
  }

  selectOption(event: KeyboardEvent, controlName: string, value: boolean): void {
    if (event.key === 'Enter') {
      this.form.get(controlName)?.setValue(value);
    }
  }

  async loadFormData() {
    const formData = sessionStorage.getItem(STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY);

    if (formData) {
      this.form.patchValue(JSON.parse(formData));
    }
  }

  createForm() {
    const formControls: { [key: string]: any[] } = {};
    this.steps.forEach(step => {
      formControls[step.controlName] = [null, Validators.required];
    });
    this.form = this.formBuilder.group(formControls);
  }

  get currentStep() {
    return this.steps[this.currentStepIndex];
  }

  get currentStepFormValue() {
    return this.form.get(this.currentStep.controlName)?.value;
  }

  nextStep() {
    if (this.currentStepIndex < this.steps.length - 1) {
      this.currentStepIndex++;
      this.radioCurrentValue = this.currentStepFormValue;
    }
  }

  prevStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }

  isFormValid(): boolean {
    return this.form.valid;
  }

  isCurrentStepValid(): boolean {
    const controlName = this.currentStep.controlName;
    const control = this.form.get(controlName);
    return control?.valid || false;
  }

  isContinueButtonDisabled(): boolean {
    return !this.isCurrentStepValid() || (this.currentStepIndex === this.steps.length - 1 && !this.isFormValid());
  }

  saveFormData() {
    const formData = this.form.value;
    sessionStorage.setItem(STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY, JSON.stringify(formData));
  }

  async closeModal() {
    this.saveFormData();
    await this.modal.dismiss({ isFormValid: this.isFormValid(), data: this.form.value });
  }

  async continue() {
    if (this.currentStepIndex < this.steps.length - 1) {
      this.nextStep();
    }else{
      this.saveFormData();
      await this.modal.dismiss({ isFormValid: this.isFormValid(), data: this.form.value });
    }
  }
}
